import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
const HtmlAd = ({ ad, width, height, useIframe = false }) => {
  const containerRef = useRef(null);
  
  console.log("passe dans html ad:", ad);
  
  if (!ad) return null;
  if (!ad.adRequestId) return null;
  
  const baseUrl = "https://peupleqc.com";

  // Si on utilise iframe, retourner l'iframe
  if (useIframe) {
    return (
      <iframe
        src={`${baseUrl}/adserver/iframe/${ad.adRequestId}`}
        style={{
          width: width,
          height: height,
          border: "none",
          overflow: "hidden",
        }}
        scrolling="no"
        title={`Ad ${ad.adRequestId}`}
      />
    );
  }

  // Hook pour exécuter les scripts après le rendu
  useEffect(() => {
    console.log("Executing script for Html Ad");

    if (!ad.ad?.media?.htmlCode || !containerRef.current)   return console.log("Not really html code?");

    const container = containerRef.current;
    const htmlCode = ad.ad.media.htmlCode;

    // Nettoyer le contenu précédent
    container.innerHTML = '';

    // Créer un div temporaire pour parser le HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlCode;    

    // Traiter d'abord les éléments non-script
    const nonScriptElements = tempDiv.querySelectorAll('*:not(script)');
    nonScriptElements.forEach(element => {
      container.appendChild(element.cloneNode(true));
    });

    // Traiter les scripts de manière séquentielle
    const scripts = Array.from(tempDiv.querySelectorAll('script'));
    
    const loadScriptsSequentially = async () => {
      for (const oldScript of scripts) {
        await new Promise((resolve, reject) => {
          const newScript = document.createElement('script');
          
          // Copier tous les attributs
          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          
          // Si c'est un script externe
          if (oldScript.src) {
            console.log("extern script:", oldScript.src);
            newScript.onload = resolve;
            newScript.onerror = reject;
            newScript.src = oldScript.src;
          } else {
            // Script inline
            newScript.innerHTML = oldScript.innerHTML;
            // Pour les scripts inline, on résout immédiatement
            setTimeout(resolve, 0);
          }
          
          container.appendChild(newScript);
        });
      }
    };

    // Exécuter le chargement séquentiel
    loadScriptsSequentially().catch(error => {
      console.error('Erreur lors du chargement des scripts publicitaires:', error);
    });

    // Nettoyer lors du démontage
    return () => {
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [ad]);

  return (
    <div
      ref={containerRef}
      style={{
        width: width,
        height: height,
      }}
    />
  );
};

export { HtmlAd };